import { textStyle } from './dimensions';


//the end of the study
const Ending = () => {
    return (
        <div style={textStyle}>Thank you for your participation!
            <br></br>
            Please click on this link to go back to Prolific: <a href="https://app.prolific.com/submissions/complete?cc=CZ96XAE8">https://app.prolific.com/submissions/complete?cc=CZ96XAE8</a>
            <br></br>
            After you have clicked the link, you can then close the present tab.</div>
    )
}

export default Ending;